import React, { useEffect, useState } from 'react';
import { ImageService } from '../../services/imageService';
import { PictureTile } from './KidUI';
import type { PictureTint } from './kidUiHelpers';

/**
 * A task or reward picture that may be a ready URL (header_image_url) or a stored image id
 * (header_image) that must be resolved first. Shows the fallback letter tile until (or unless)
 * a real picture is available — never a broken image (design rule).
 */
export const StoredPicture: React.FC<{
  url?: string | null;
  imageId?: string | null;
  label: string;
  size?: number | 'fill';
  tint?: PictureTint;
  rounded?: string;
  className?: string;
  fit?: 'contain' | 'cover';
}> = ({ url, imageId, label, size = 72, tint, rounded, className, fit }) => {
  const [resolved, setResolved] = useState<string | null>(url || null);

  useEffect(() => {
    let cancelled = false;
    if (url) {
      setResolved(url);
      return;
    }
    setResolved(null);
    if (!imageId) return;
    if (/^(https?:|\/)/.test(imageId)) {
      setResolved(imageId);
      return;
    }
    ImageService.getImageURL(imageId)
      .then((u) => { if (!cancelled && u) setResolved(u); })
      .catch(() => { /* keep the fallback tile */ });
    return () => { cancelled = true; };
  }, [url, imageId]);

  return <PictureTile src={resolved} label={label} size={size} tint={tint} rounded={rounded} className={className} fit={fit} />;
};

export default StoredPicture;
